<template>
  <button
    @click.prevent="onClick"
    type="submit"
    :disabled="disabled"
    :class="[
      className,
      'button flex justify-center',
      loader ? 'fade' : '',
      disabled ? 'disabled' : ''
    ]"
  >
    <div class="beforeIcon" v-if="iconUrl">
      <img :src="`/${iconUrl}.png`" alt="" />
    </div>
    <span v-if="!loader">
      {{ title }}
    </span>
    <div v-else class="loader"></div>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean
    },
    loader: {
      type: Boolean,
      default: false
    },

    onClick: {
      type: Function,
      default: () => {}
    },

    className: {
      type: String
    },

    iconUrl: {
      type: String
    }
  }
};
</script>

<style>
.button {
  padding: 9px 22px;
  border-radius: var(--radius-sm);
  outline: none;
  cursor: pointer;
  -webkit-transition: background-color var(--dur) var(--ease),
    border-color var(--dur) var(--ease), box-shadow var(--dur) var(--ease);
  transition: background-color var(--dur) var(--ease),
    border-color var(--dur) var(--ease), box-shadow var(--dur) var(--ease);
}
.button span {
  font-family: var(--font-sans);
  font-style: normal;
  font-weight: 400;
  font-size: var(--fs-body);
  line-height: 1.45;
  letter-spacing: 0;
  color: #ffffff;
}
.button--primary {
  background: var(--grad-accent);
  border: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.14);
}
.button--primary:hover {
  background: var(--grad-accent-hover);
}
.button--secondary {
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--line-strong);
}
.button--info {
  background: transparent;
  border: 1px solid var(--accent-600);
  box-sizing: border-box;
  border-radius: var(--radius-sm);
  color: var(--accent-600);
}
.button--grey--light {
  color: #636363 !important;
  background: #ffffff;
  border: 1px solid #dfdfdf;
  box-sizing: border-box;
  border-radius: 2px;
}
.button--transparent {
  border: 1px solid #c8c8c8;
  box-sizing: border-box;
  border-radius: 4px;
  background: transparent;
}
.button--transparent span {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #626262;
}
.button--block {
  width: 100%;
}
.icon {
  position: relative;
  top: 2px;
  margin-left: 10px;
}
.fade {
  opacity: 0.8;
}
.beforeIcon {
  display: inline-block;
  margin-right: 10px;
}
.no-vertical-padding {
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.disabled {
  opacity: 0.7;
  pointer-events: none;
}
.loader {
  position: relative;
  display: inline-block;
  top: 2px;
  /* right: -10px; */
  border: 2px solid rgba(255, 255, 255, 0.55);
  border-radius: 50%;
  border-top: 2px solid #ffffff;
  width: 20px;
  height: 20px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
